export const CAPTCHA = {
	question: 'login-captcha-question',
	input: 'login-captcha-input',
	refresh: 'login-captcha-refresh-button',
	error: 'login-error-message',
};

export const PASSPORT = {
	departureInput: 'passport-departure-input',
	expiryInput: 'passport-expiry-input',
	result: 'passport-result',
	status: 'passport-status',
	remaining: 'passport-remaining',
	minDate: 'passport-min-date',
	reset: 'passport-reset-button',
	placeholder: 'passport-placeholder',
	tabSingle: 'passport-tab-single',
	tabGroup: 'passport-tab-group',
};

export const GROUP = {
	row: 'group-row',
	rowName: 'group-row-name-input',
	rowExpiry: 'group-row-expiry-input',
	rowStatus: 'group-row-status',
	rowRemove: 'group-row-remove-button',
	addRow: 'group-add-row-button',
	clear: 'group-clear-button',
	summary: 'group-summary',
	validCount: 'group-valid-count',
	expiredCount: 'group-expired-count',
	pasteButton: 'group-paste-button',
};

export const PASTE = {
	dialog: 'paste-dialog',
	textarea: 'paste-textarea',
	preview: 'paste-preview',
	okCount: 'paste-ok-count',
	rowsPreview: 'paste-rows-preview',
	failed: 'paste-failed-list',
	apply: 'paste-apply-button',
};

export const LANDING = {
	page: 'landing-page',
	hero: 'landing-hero',
	heroCta: 'landing-hero-cta',
	navServices: 'landing-nav-services',
	navContact: 'landing-nav-contact',
	services: 'landing-services',
	band: 'landing-parallax-band',
	contactBand: 'landing-contact-band',
	ctaInstagram: 'landing-cta-instagram',
	ctaEmail: 'landing-cta-email',
	footer: 'landing-footer',
	address: 'landing-footer-address',
	instagram: 'landing-footer-instagram',
	email: 'landing-footer-email',
	staffLogin: 'landing-staff-login-link',
};

export const AUDIT = {
	row: 'audit-row',
	time: 'audit-row-time',
	refresh: 'audit-refresh-button',
	filter: 'audit-filter',
	count: 'audit-count',
	empty: 'audit-empty',
	loadMore: 'audit-load-more-button',
};

export const BOOKINGS = {
	addButton: 'bookings-add-button',
	refresh: 'bookings-refresh-button',
	search: 'bookings-search-input',
	filter: 'bookings-filter',
	row: 'bookings-row',
	deadline: 'bookings-deadline',
	editButton: 'bookings-edit-button',
	deleteButton: 'bookings-delete-button',
	empty: 'bookings-empty',
	card: 'bookings-card',
	cardEmpty: 'bookings-card-empty',
	cardEdit: 'bookings-card-edit-button',
	cardDelete: 'bookings-card-delete-button',
};

export const BOOKING_FORM = {
	dialog: 'booking-form-dialog',
	name: 'booking-form-name-input',
	code: 'booking-form-code-input',
	payment: 'booking-form-payment-input',
	guest: 'booking-form-guest-input',
	paid: 'booking-form-paid-checkbox',
	guestDone: 'booking-form-guest-done-checkbox',
	submit: 'booking-form-submit-button',
};

export const REMINDER_POPUP = {
	dialog: 'reminder-popup',
	item: 'reminder-popup-item',
	close: 'reminder-popup-close-button',
	open: 'reminder-popup-open-button',
};

export const NOTIFY = {
	whatsappStatus: 'notify-whatsapp-status',
	usersLink: 'notify-users-link',
	row: 'notify-user-row',
	rowToggle: 'notify-user-row-toggle',
	email: 'notify-email-input',
	waPhone: 'notify-wa-phone-input',
	waKey: 'notify-wa-key-input',
	clearWa: 'notify-clear-wa-key-button',
	test: 'notify-test-button',
	telegramStatus: 'notify-telegram-status',
	save: 'notify-save-button',
};

export const SHELL = {
	navBookings: 'nav-bookings-link',
	navNotify: 'nav-notify-link',
	navAudit: 'nav-audit-link',
	navPassport: 'nav-passport-link',
	navQuickReply: 'nav-quick-reply-link',
	navCategories: 'nav-categories-link',
	navUsers: 'nav-users-link',
	userName: 'shell-user-name',
	userRole: 'shell-user-role',
	mobileMenu: 'shell-mobile-menu-button',
};

export const QR = {
	search: 'qr-search-input',
	chip: 'qr-category-chip',
	addButton: 'qr-add-template-button',
	refreshIndicator: 'qr-refresh-indicator',
	refreshNow: 'qr-refresh-now-button',
	card: 'qr-template-card',
	copyButton: 'qr-copy-button',
	editButton: 'qr-edit-button',
	deleteButton: 'qr-delete-button',
	empty: 'qr-empty-state',
	count: 'qr-result-count',
	monthSelect: 'qr-month-select',
	yearSelect: 'qr-year-select',
	sortSelect: 'qr-sort-select',
	cardDate: 'qr-card-date',
};

export const TPL_FORM = {
	dialog: 'template-form-dialog',
	title: 'template-form-title-input',
	category: 'template-form-category-select',
	keywords: 'template-form-keywords-input',
	content: 'template-form-content-input',
	month: 'template-form-month',
	year: 'template-form-year-select',
	submit: 'template-form-submit-button',
};

export const CONFIRM = {
	dialog: 'confirm-delete-dialog',
	confirm: 'confirm-delete-button',
	cancel: 'confirm-cancel-button',
};

export const CAT = {
	nameInput: 'category-name-input',
	addButton: 'category-add-button',
	row: 'category-row',
	editInput: 'category-edit-input',
	editButton: 'category-edit-button',
	saveButton: 'category-save-button',
	deleteButton: 'category-delete-button',
};

export const USERS = {
	addButton: 'users-add-button',
	row: 'users-row',
	editButton: 'users-edit-button',
	deleteButton: 'users-delete-button',
	activeSwitch: 'users-active-switch',
	roleBadge: 'users-role-badge',
	lockedLabel: 'users-locked-label',
	formUsername: 'user-form-username-input',
	formName: 'user-form-name-input',
	formPassword: 'user-form-password-input',
	formRole: 'user-form-role-select',
	formSubmit: 'user-form-submit-button',
	formEmail: 'user-form-email-input',
	formWaPhone: 'user-form-wa-phone-input',
	formWaKey: 'user-form-wa-key-input',
	formClearWaKey: 'user-form-clear-wa-key-checkbox',
};
